export enum ListType {
  'SIMPLE_DETAIL' = 'SIMPLE_DETAIL',
  'ADVANCED' = 'ADVANCED',
  'SIMPLE' = 'SIMPLE',
}
